/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { type GoalProgress, progressApi, type TimelineEntry } from '../api/progress.js';

export function useChildProgress(
  clientId: string,
  enabled = true,
): UseQueryResult<readonly GoalProgress[]> {
  return useQuery({
    queryKey: ['clients', clientId, 'progress'],
    queryFn: () => progressApi.forClient(clientId),
    enabled: enabled && clientId !== '',
  });
}

export function useChildTimeline(
  clientId: string,
  enabled = true,
): UseQueryResult<readonly TimelineEntry[]> {
  return useQuery({
    queryKey: ['clients', clientId, 'timeline'],
    queryFn: () => progressApi.timeline(clientId),
    enabled: enabled && clientId !== '',
  });
}
